/* OAY category shop: Pack of 2 style cards that add straight to the cart,
   with quick view, size chart drawer, image sliders and a "Shop by size" grid. */
(function () {
  var ROOT = document.querySelector('[data-oay-cat]');
  if (!ROOT || ROOT._oay) return;
  ROOT._oay = true;
  var ID = ROOT.dataset.sectionId;
  var ADD_TEXT = ROOT.dataset.addText || 'Add to cart';
  var $ = function (id) { return document.getElementById(id + '-' + ID); };
  var grid = $('bp-product-grid');

  function inr(cents) { return '\u20b9' + Math.round((parseInt(cents, 10) || 0) / 100).toLocaleString('en-IN'); }
  function half(cents) { return '\u20b9' + Math.round((parseInt(cents, 10) || 0) / 200).toLocaleString('en-IN'); }

  var ICON = {
    warning: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>',
    success: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>',
    error: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><circle cx="12" cy="16" r="1" fill="currentColor"/></svg>',
    spinner: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="animation:spin 1s linear infinite"><circle cx="12" cy="12" r="10" stroke-dasharray="30 60"/></svg>'
  };
  function toast(msg, type) {
    type = type || 'success';
    var t = document.createElement('div');
    t.className = 'bundle-toast bundle-toast--' + type;
    t.innerHTML = (ICON[type] || ICON.success) + '<span class="bundle-toast__text"></span>';
    t.lastChild.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () { t.style.opacity = '0'; t.style.transform = 'translateY(20px)'; setTimeout(function () { t.remove(); }, 300); }, 2600);
  }

  /* ---------- card image sliders ---------- */
  var lastWasDrag = false;
  function initSliders(scope) {
    if (typeof Swiper === 'undefined') return;
    scope.querySelectorAll('[data-product-slider]').forEach(function (el) {
      if (el.swiper) return;
      var sw = new Swiper(el, { loop: true, pagination: { el: el.querySelector('.swiper-pagination'), clickable: true }, speed: 300, threshold: 8 });
      sw.on('touchStart', function () { lastWasDrag = false; });
      sw.on('touchMove', function () { lastWasDrag = true; });
      sw.on('slideChange', function () { lastWasDrag = true; });
    });
  }
  function initVideos(scope) {
    var vids = scope.querySelectorAll('.bp-card__video');
    vids.forEach(function (v) { v.playsInline = true; v.muted = true; v.setAttribute('playsinline', ''); });
    if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { v.play().catch(function () {}); }); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { e.isIntersecting ? e.target.play().catch(function () {}) : e.target.pause(); }); }, { threshold: 0.25 });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* ---------- size swatch on a card ---------- */
  function pickSwatch(sw) {
    var card = sw.closest('.bp-card');
    var group = card.querySelector('[data-swatch-group]');
    var input = card.querySelector('input[data-variant-select]');
    group.querySelectorAll('[data-swatch]').forEach(function (s) { s.classList.remove('bp-card__swatch--active'); });
    sw.classList.add('bp-card__swatch--active');
    group.classList.remove('oay-need-size');
    if (input) input.value = sw.dataset.variantId;
    var cmp = parseInt(sw.dataset.comparePrice, 10) || 0;
    var now = parseInt(sw.dataset.price, 10) || 0;
    /* Post-sale: show the real price; strike the MRP only when there is a real discount */
    var mrp = cmp > now ? cmp : now;
    var was = card.querySelector('.bp-card__price');
    var arrow = card.querySelector('.oay-bp-arrow');
    if (was) { was.textContent = inr(mrp); was.style.display = cmp > now ? '' : 'none'; }
    if (arrow) arrow.style.display = cmp > now ? '' : 'none';
    var nowEl = card.querySelector('[data-oay-now]');
    if (nowEl && now) nowEl.textContent = inr(now);
  }

  /* ---------- add one piece to the cart ---------- */
  function addToCart(card, btn, forcedId) {
    var group = card.querySelector('[data-swatch-group]');
    if (!forcedId && group && group.querySelector('[data-swatch]') && !group.querySelector('.bp-card__swatch--active')) {
      group.classList.remove('oay-need-size'); void group.offsetWidth; group.classList.add('oay-need-size');
      toast('Pick your size first', 'warning');
      return Promise.resolve(false);
    }
    var input = card.querySelector('input[data-variant-select]');
    var id = forcedId || (input && input.value);
    if (!id || !btn) return Promise.resolve(false);
    var label = btn.querySelector('span');
    var old = label ? label.textContent : '';
    btn.disabled = true;
    if (label) label.textContent = 'Adding\u2026';
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw new Error(j.description || 'Could not add. Please try again.'); return j; });
    }).then(function () {
      if (label) label.textContent = 'Added \u2713';
      setTimeout(function () { if (label) label.textContent = old; }, 1800);
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      var cartLink = document.querySelector('.header a[href$="/cart"], a.header__icon-wrapper[href*="/cart"]');
      if (cartLink) setTimeout(function () { cartLink.click(); }, 150);
      return true;
    }).catch(function (err) {
      if (label) label.textContent = old;
      toast(err.message || 'Could not add. Please try again.', 'warning');
      return false;
    }).then(function (ok) { btn.disabled = false; return ok; });
  }

  /* ---------- size chart drawer ---------- */
  var drawer = $('size-chart-drawer'), drawerBg = $('size-chart-overlay'), drawerBody = $('size-chart-content');
  var chartCache = {};
  function findChart(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector('size-chart') || doc.querySelector('.size-wrapper') || doc.querySelector('.page__content') ||
      doc.querySelector('.rte') || doc.querySelector('main .shopify-section') || doc.querySelector('article');
  }
  function openChart(handle) {
    if (!drawer) return;
    drawer.classList.add('active'); drawerBg.classList.add('active');
    document.body.style.overflow = 'hidden';
    if (chartCache[handle]) { drawerBody.innerHTML = chartCache[handle]; return; }
    drawerBody.innerHTML = '<div class="size-chart-drawer__empty">' + ICON.spinner + '<p>Loading size chart...</p></div>';
    if (!handle) { drawerBody.innerHTML = '<div class="size-chart-drawer__empty">' + ICON.error + '<p>Size chart not available for this product</p></div>'; return; }
    fetch('/pages/' + handle).then(function (r) { if (!r.ok) throw 0; return r.text(); }).then(function (html) {
      var c = findChart(html);
      var out = c ? (c.tagName === 'SIZE-CHART' ? c.outerHTML : '<size-chart>' + c.outerHTML + '</size-chart>') : '';
      if (!out) throw 0;
      chartCache[handle] = out;
      drawerBody.innerHTML = out;
    }).catch(function () {
      drawerBody.innerHTML = '<div class="size-chart-drawer__empty">' + ICON.error + '<p>Size chart not available for this product</p></div>';
    });
  }
  function closeChart() {
    if (!drawer) return;
    drawer.classList.remove('active'); drawerBg.classList.remove('active');
    document.body.style.overflow = '';
  }
  $('size-chart-close') && $('size-chart-close').addEventListener('click', closeChart);
  drawerBg && drawerBg.addEventListener('click', closeChart);

  /* ---------- quick view ---------- */
  var qv = {
    overlay: $('bp-quickview-overlay'), swiperEl: $('bp-quickview-swiper'), slides: $('bp-quickview-slides'),
    title: $('bp-quickview-title'), coll: $('bp-quickview-collection'), price: $('bp-quickview-price'),
    compare: $('bp-quickview-compare'), discount: $('bp-quickview-discount'), swatches: $('bp-quickview-swatches'),
    area: $('bp-quickview-variant-area'), idInput: $('bp-quickview-variant-id'), atc: $('bp-quickview-atc'),
    link: $('bp-quickview-link'), details: $('bp-qv-panel-details'), chart: $('bp-qv-panel-sizechart'),
    swiper: null, card: null, chartHandle: '', chartLoaded: false, selected: null
  };
  function qvTabs(first) {
    var tabs = qv.overlay.querySelectorAll('.bp-qv-tab'), panels = qv.overlay.querySelectorAll('.bp-qv-tab-panel');
    tabs.forEach(function (t, i) { t.classList.toggle('bp-qv-tab--active', i === 0); });
    panels.forEach(function (p, i) { p.classList.toggle('bp-qv-tab-panel--active', i === 0); });
  }
  function qvLoadChart() {
    var h = qv.chartHandle;
    qv.chartLoaded = true;
    if (!h) { qv.chart.innerHTML = '<div class="bp-qv-size-chart-empty">Size chart not available for this product.</div>'; return; }
    if (chartCache['qv:' + h]) { qv.chart.innerHTML = chartCache['qv:' + h]; return; }
    qv.chart.innerHTML = '<div class="bp-qv-size-chart-loading">Loading size chart...</div>';
    fetch('/pages/' + h).then(function (r) { if (!r.ok) throw 0; return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var c = doc.querySelector('.size-wrapper') || doc.querySelector('.page__content') || doc.querySelector('.rte') || doc.querySelector('main .shopify-section') || doc.querySelector('article');
      var out = c ? c.outerHTML : '<div class="bp-qv-size-chart-empty">Size chart content not found.</div>';
      chartCache['qv:' + h] = out;
      qv.chart.innerHTML = out;
    }).catch(function () { qv.chart.innerHTML = '<div class="bp-qv-size-chart-empty">Unable to load size chart.</div>'; });
  }
  if (qv.overlay) {
    qv.overlay.querySelectorAll('.bp-qv-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.dataset.qvTab;
        qv.overlay.querySelectorAll('.bp-qv-tab').forEach(function (t) { t.classList.toggle('bp-qv-tab--active', t === tab); });
        qv.overlay.querySelectorAll('.bp-qv-tab-panel').forEach(function (p) { p.classList.toggle('bp-qv-tab-panel--active', p.dataset.qvPanel === target); });
        if (target === 'sizechart' && !qv.chartLoaded) qvLoadChart();
      });
    });
    qv.chart.addEventListener('click', function (e) {
      if (e.target.tagName !== 'I') return;
      var w = qv.chart.querySelector('.size-wrapper'); if (!w) return;
      var car = w.querySelector('.table-carousel'), tw = w.querySelector('.table-wrapper');
      if (car && tw) car.scrollLeft += e.target.classList.contains('size-inch') ? -tw.clientWidth : tw.clientWidth;
      w.querySelectorAll('i').forEach(function (i) { i.classList.remove('active-btn'); });
      e.target.classList.add('active-btn');
    });
    $('bp-quickview-close').addEventListener('click', qvClose);
    qv.overlay.addEventListener('click', function (e) { if (e.target === qv.overlay) qvClose(); });
    qv.atc.addEventListener('click', function () {
      if (!qv.selected || !qv.selected.available || !qv.card) return;
      var id = qv.idInput.value;
      var sw = qv.card.querySelector('[data-swatch][data-variant-id="' + id + '"]');
      if (sw) pickSwatch(sw);
      addToCart(qv.card, qv.atc, id).then(function (ok) { if (ok) qvClose(); });
    });
  }
  function parseData(s) { try { return JSON.parse((s || '[]').replace(/&quot;/g, '"').replace(/&amp;/g, '&')); } catch (e) { return []; } }
  function qvSelect(btn) {
    qv.swatches.querySelectorAll('.bp-quickview__swatch').forEach(function (s) { s.classList.remove('bp-quickview__swatch--active'); });
    btn.classList.add('bp-quickview__swatch--active');
    var v = { id: btn.dataset.qvVariantId, price: parseInt(btn.dataset.qvPrice, 10), compare: parseInt(btn.dataset.qvCompare, 10) || 0, available: btn.dataset.qvAvailable === 'true', image: btn.dataset.qvImage };
    qv.selected = v;
    qv.idInput.value = v.id;
    var hasOff = v.compare > v.price;
    qv.price.textContent = inr(v.price);
    qv.compare.textContent = inr(v.compare); qv.compare.style.display = hasOff ? '' : 'none';
    qv.discount.textContent = hasOff ? '-' + Math.round((v.compare - v.price) * 100 / v.compare) + '%' : ''; qv.discount.style.display = hasOff ? '' : 'none';
    qv.atc.disabled = !v.available;
    var span = qv.atc.querySelector('span'); if (span) span.textContent = v.available ? ADD_TEXT : 'Sold Out';
    if (v.image && qv.swiper) {
      qv.swiperEl.querySelectorAll('.swiper-slide img').forEach(function (img, i) { if (img.src === v.image) qv.swiper.slideTo(i); });
    }
  }
  function qvOpen(btn) {
    if (!qv.overlay) return;
    qv.card = btn.closest('.bp-card');
    var d = btn.dataset, images = parseData(d.productImages), variants = parseData(d.productVariants);
    if (!images.length) { var im = qv.card.querySelector('.bp-card__image'); if (im && im.src) images = [im.src]; }
    qv.title.textContent = d.productTitle || '';
    qv.link.href = d.productUrl || '#';
    qv.coll.textContent = d.productCollection || '';
    qv.coll.style.display = d.productCollection ? '' : 'none';
    var desc = d.productDescription || '';
    qv.details.innerHTML = '';
    var p = document.createElement('p');
    if (desc) p.textContent = desc; else { p.textContent = 'No description available.'; p.style.color = '#888780'; }
    qv.details.appendChild(p);
    qv.chartHandle = d.productSizeChart || ''; qv.chartLoaded = false;
    qv.chart.innerHTML = '<div class="bp-qv-size-chart-loading">Loading size chart...</div>';
    qvTabs();
    qv.slides.innerHTML = '';
    images.forEach(function (src) {
      var s = document.createElement('div'); s.className = 'swiper-slide';
      var img = document.createElement('img'); img.src = src; img.alt = d.productTitle || ''; img.loading = 'lazy';
      s.appendChild(img); qv.slides.appendChild(s);
    });
    if (qv.swiper) { qv.swiper.destroy(true, true); qv.swiper = null; }
    qv.swatches.innerHTML = '';
    if (variants.length) {
      qv.area.style.display = '';
      variants.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'bp-quickview__swatch' + (v.available ? '' : ' bp-quickview__swatch--unavailable');
        b.dataset.qvVariantId = v.id; b.dataset.qvPrice = v.price; b.dataset.qvCompare = v.compareAtPrice;
        b.dataset.qvAvailable = v.available; b.dataset.qvImage = v.image || '';
        b.disabled = !v.available;
        b.textContent = String(v.title).split('.')[0].split('/')[0].trim();
        b.addEventListener('click', function () { qvSelect(b); });
        qv.swatches.appendChild(b);
      });
      var cardPick = qv.card.querySelector('.bp-card__swatch--active');
      var first = (cardPick && qv.swatches.querySelector('[data-qv-variant-id="' + cardPick.dataset.variantId + '"]:not([disabled])')) ||
        qv.swatches.querySelector('.bp-quickview__swatch:not([disabled])');
      if (first) qvSelect(first);
    } else { qv.area.style.display = 'none'; }
    qv.overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    setTimeout(function () {
      if (typeof Swiper === 'undefined') return;
      qv.swiper = new Swiper(qv.swiperEl, {
        loop: images.length > 1,
        pagination: { el: qv.swiperEl.querySelector('.swiper-pagination'), clickable: true },
        navigation: { prevEl: qv.swiperEl.querySelector('.swiper-button-prev'), nextEl: qv.swiperEl.querySelector('.swiper-button-next') },
        speed: 300, threshold: 10, touchAngle: 45, touchReleaseOnEdges: true
      });
    }, 50);
  }
  function qvClose() {
    if (!qv.overlay) return;
    qv.overlay.classList.remove('active');
    document.body.style.overflow = '';
    if (qv.swiper) { qv.swiper.destroy(true, true); qv.swiper = null; }
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (qv.overlay && qv.overlay.classList.contains('active')) qvClose();
    if (drawer && drawer.classList.contains('active')) closeChart();
  });

  /* ---------- clicks inside the grid ---------- */
  grid.addEventListener('click', function (e) {
    var t = e.target;
    var q = t.closest('[data-quick-view]');
    if (q) { e.preventDefault(); qvOpen(q); return; }
    var chart = t.closest('[data-size-chart-trigger]');
    if (chart) { e.preventDefault(); openChart(chart.dataset.sizeChartHandle); return; }
    var sw = t.closest('[data-swatch]');
    if (sw) { pickSwatch(sw); return; }
    var add = t.closest('[data-add-to-bundle]');
    if (add) { addToCart(add.closest('.bp-card'), add); return; }
    var img = t.closest('.bp-card__image');
    if (img && !lastWasDrag) {
      var qb = img.closest('.bp-card').querySelector('[data-quick-view]');
      var url = qb && qb.getAttribute('data-product-url');
      if (url) { e.preventDefault(); window.location.href = url; }
    }
  });

  /* ---------- "Shop by size" grid ---------- */
  var sizeBtns = ROOT.querySelectorAll('[data-ss-size]');
  var countEl = ROOT.querySelector('[data-ss-count]');
  var emptyEl = ROOT.querySelector('[data-ss-empty]');
  var loader = $('bp-scroll-loader');
  var current = '';
  function sizeKey(txt) {
    var k = String(txt || '').replace(/\u00a0/g, ' ').trim().split(/[\s(.\/]/)[0].toUpperCase();
    if (k === '2XL') k = 'XXL';
    if (k === 'XXXL') k = '3XL';
    return k;
  }
  function applySize(size) {
    current = size;
    sizeBtns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.ssSize === size)); });
    size ? ROOT.setAttribute('data-size', size) : ROOT.removeAttribute('data-size');
    var shown = 0;
    grid.querySelectorAll('.bp-card').forEach(function (card) {
      var sws = Array.prototype.slice.call(card.querySelectorAll('[data-swatch]'));
      var match = null;
      if (size) sws.forEach(function (b) { if (!match && sizeKey(b.textContent) === size) match = b; });
      var show = !size || !sws.length || !!match;
      card.hidden = !show;
      if (!show) return;
      shown++;
      if (match) { if (!match.classList.contains('bp-card__swatch--active')) pickSwatch(match); }
      else if (!size) sws.forEach(function (b) { b.classList.remove('bp-card__swatch--active'); });
    });
    placeTimer();
    var more = loader && loader.isConnected;
    if (emptyEl) emptyEl.hidden = shown > 0 || !!more;
    if (countEl) countEl.textContent = shown + (shown === 1 ? ' style' : ' styles') + (size ? ' in ' + size : '');
    if (sizeBtns.length) { try { size ? sessionStorage.setItem('oay-ss-size', size) : sessionStorage.removeItem('oay-ss-size'); } catch (e) {} }
    if (more && loader.getBoundingClientRect().top < window.innerHeight + 600) setTimeout(loadMore, 0);
  }
  /* keep the "Once a year" timer strip after the Nth product that is still showing,
     so a size filter never leaves one lonely card above it */
  var timerAfter = 4;
  try { timerAfter = Math.max(1, parseInt(JSON.parse(document.getElementById('oay-config').textContent).gridAfter, 10) || 4); } catch (e) {}
  function placeTimer() {
    var gc = grid.querySelector(':scope > .oay-gridcard');
    if (!gc) return;
    var vis = Array.prototype.filter.call(grid.querySelectorAll(':scope > .bp-card'), function (c) { return !c.hidden; });
    if (vis.length > timerAfter) { gc.hidden = false; if (vis[timerAfter - 1].nextElementSibling !== gc) vis[timerAfter - 1].insertAdjacentElement('afterend', gc); }
    else gc.hidden = true;
  }
  if ('MutationObserver' in window) {
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        for (var j = 0; j < list[i].addedNodes.length; j++) {
          var n = list[i].addedNodes[j];
          if (n.nodeType === 1 && n.classList.contains('oay-gridcard')) { placeTimer(); return; }
        }
      }
    }).observe(grid, { childList: true });
  }

  ROOT.addEventListener('click', function (e) {
    var t = e.target.closest('[data-ss-size],[data-ss-clear]');
    if (!t) return;
    applySize(t.hasAttribute('data-ss-clear') || t.getAttribute('aria-pressed') === 'true' ? '' : t.dataset.ssSize);
    var bar = ROOT.querySelector('.oay-cat__sizes');
    var top = grid.getBoundingClientRect().top + window.scrollY - (bar ? bar.offsetHeight : 0) - 70;
    if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
  });

  /* ---------- infinite scroll ---------- */
  var loading = false, io = null;
  function loadMore() {
    if (!loader || !loader.isConnected || loading) return;
    var next = loader.dataset.nextUrl;
    if (!next) return;
    loading = true;
    var wrapId = ROOT.closest('.shopify-section').id.replace('shopify-section-', '');
    fetch(next + (next.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + wrapId)
      .then(function (r) { if (!r.ok) throw 0; return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var ng = doc.getElementById('bp-product-grid-' + ID);
        var cards = ng ? ng.querySelectorAll('.bp-card') : [];
        cards.forEach(function (c) {
          var clone = document.importNode(c, true);
          grid.insertBefore(clone, loader);
          initSliders(clone); initVideos(clone);
        });
        var nl = doc.getElementById('bp-scroll-loader-' + ID);
        if (cards.length && nl && nl.dataset.nextUrl) loader.dataset.nextUrl = nl.dataset.nextUrl;
        else { loader.remove(); if (io) io.disconnect(); }
      })
      .catch(function () { loader.remove(); if (io) io.disconnect(); })
      .then(function () { loading = false; applySize(current); });
  }
  if (loader && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) loadMore(); }, { rootMargin: '600px' });
    io.observe(loader);
  }

  /* ---------- size-chart element (inch / cm toggle) ---------- */
  if (!customElements.get('size-chart')) {
    customElements.define('size-chart', class extends HTMLElement {
      connectedCallback() {
        if (this._b) return; this._b = true;
        var self = this;
        this.addEventListener('click', function (e) {
          if (e.target.tagName !== 'I') return;
          var w = self.querySelector('.size-wrapper'); if (!w) return;
          var car = w.querySelector('.table-carousel'), tw = w.querySelector('.table-wrapper');
          if (car && tw) car.scrollLeft += e.target.classList.contains('size-inch') ? -tw.clientWidth : tw.clientWidth;
          w.querySelectorAll('i').forEach(function (i) { i.classList.remove('active-btn'); });
          e.target.classList.add('active-btn');
        });
      }
    });
  }

  var start = '';
  try { start = sessionStorage.getItem('oay-ss-size') || ''; } catch (e) {}
  if (!sizeBtns.length) start = '';   // pages without the size row (e.g. Classic Shirt) never filter
  applySize(start);
  initVideos(grid);
  if (typeof Swiper === 'undefined') window.addEventListener('load', function () { initSliders(grid); }); else initSliders(grid);
})();
